// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/rag.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Param } from "./param_pb.js";
import { file_agentplatform_v1_param } from "./param_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/rag.proto.
 */
export const file_agentplatform_v1_rag: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_v1_param]);

/**
 * 定义 RAG 服务
 *
 * @generated from message infinigence.infini.agentplatform.v1.RAG
 */
export type RAG = Message<"infinigence.infini.agentplatform.v1.RAG"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * RAG 服务名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * RAG 服务描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * 所属 RAG 类 ID（由 RAG 类模板实例化时写入；知识库 collection 行可为空）
   * @gotags: json:"class_id,omitempty"
   *
   * @generated from field: string class_id = 7 [json_name = "class_id"];
   */
  classId: string;

  /**
   * 使用 RAG 类创建实例时传入的参数列表
   * @gotags: json:"class_params,omitempty"
   *
   * @generated from field: map<string, string> class_params = 8 [json_name = "class_params"];
   */
  classParams: { [key: string]: string };

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 9 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 10 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 11 [json_name = "deleted_at"];
   */
  deletedAt: bigint;

  /**
   * RAG 组服务提供者（与 SkillGroup.provider 对齐）
   * @gotags: json:"provider,omitempty"
   *
   * @generated from field: string provider = 12;
   */
  provider: string;

  /**
   * 引用的知识库集合 ID 列表（rag_collections.id，即 Qdrant collection 名）
   * @gotags: json:"collections,omitempty"
   *
   * @generated from field: repeated string collections = 13;
   */
  collections: string[];

  /**
   * 向量检索默认返回的最大片段条数（REST 工具调用未显式传 top_k 时使用）；越大召回越多、上下文越长，建议 4～10
   * @gotags: json:"default_search_top_k,omitempty"
   *
   * @generated from field: int32 default_search_top_k = 14 [json_name = "default_search_top_k"];
   */
  defaultSearchTopK: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.RAG.
 * Use `create(RAGSchema)` to create a new message.
 */
export const RAGSchema: GenMessage<RAG> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_rag, 0);

/**
 * 定义 RAG 类
 *
 * @generated from message infinigence.infini.agentplatform.v1.RAGClass
 */
export type RAGClass = Message<"infinigence.infini.agentplatform.v1.RAGClass"> & {
  /**
   * 资源编号
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * RAG 类名称
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * RAG 类描述
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * RAG Template
   * @gotags: json:"template,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAG template = 10;
   */
  template?: RAG | undefined;

  /**
   * RAG 类参数
   * @gotags: json:"params,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.Param params = 11;
   */
  params: Param[];

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 12 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 13 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 14 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.RAGClass.
 * Use `create(RAGClassSchema)` to create a new message.
 */
export const RAGClassSchema: GenMessage<RAGClass> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_rag, 1);

/**
 * 知识库向量集合登记（原 rags 表中用于 Qdrant collection 的 id/name 语义）
 *
 * @generated from message infinigence.infini.agentplatform.v1.RAGCollection
 */
export type RAGCollection = Message<"infinigence.infini.agentplatform.v1.RAGCollection"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @gotags: json:"description,omitempty"
   *
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @gotags: json:"author,omitempty"
   *
   * @generated from field: string author = 4;
   */
  author: string;

  /**
   * 租户 ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 5 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 用户 ID
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 6 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @gotags: json:"status"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.RAGCollectionStatus status = 7;
   */
  status: RAGCollectionStatus;

  /**
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 8 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 9 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 10 [json_name = "deleted_at"];
   */
  deletedAt: bigint;

  /**
   * rag Qdrant 向量维度；0 表示未设置，创建/入库由上游默认
   * @gotags: json:"vector_size,omitempty"
   *
   * @generated from field: int32 vector_size = 11 [json_name = "vector_size"];
   */
  vectorSize: number;

  /**
   * rag 分块重叠字符数；0 表示未设置，入库由上游默认
   * @gotags: json:"chunk_overlap,omitempty"
   *
   * @generated from field: int32 chunk_overlap = 12 [json_name = "chunk_overlap"];
   */
  chunkOverlap: number;

  /**
   * rag Qdrant 距离度量（cosine / euclid / dot）；空表示由上游默认 cosine
   * @gotags: json:"distance,omitempty"
   *
   * @generated from field: string distance = 13;
   */
  distance: string;

  /**
   * 服务端实际 embedding 模型标识，只读；一期为 qwen3-vl-embedding。
   * @gotags: json:"embedding_profile_id,omitempty"
   *
   * @generated from field: string embedding_profile_id = 14 [json_name = "embedding_profile_id"];
   */
  embeddingProfileId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.RAGCollection.
 * Use `create(RAGCollectionSchema)` to create a new message.
 */
export const RAGCollectionSchema: GenMessage<RAGCollection> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_rag, 2);

/**
 * 与 Cortex SkillStatus 取值对齐：0 不可用，1 可用，2 上传中
 *
 * @generated from enum infinigence.infini.agentplatform.v1.RAGCollectionStatus
 */
export enum RAGCollectionStatus {
  /**
   * @generated from enum value: RAG_COLLECTION_UNAVAILABLE = 0;
   */
  RAG_COLLECTION_UNAVAILABLE = 0,

  /**
   * @generated from enum value: RAG_COLLECTION_AVAILABLE = 1;
   */
  RAG_COLLECTION_AVAILABLE = 1,

  /**
   * @generated from enum value: RAG_COLLECTION_UPLOADING = 2;
   */
  RAG_COLLECTION_UPLOADING = 2,
}

/**
 * Describes the enum infinigence.infini.agentplatform.v1.RAGCollectionStatus.
 */
export const RAGCollectionStatusSchema: GenEnum<RAGCollectionStatus> = /*@__PURE__*/
  enumDesc(file_agentplatform_v1_rag, 0);

